// extracted by mini-css-extract-plugin
export default {"vendor":"vendor-bSzw","google":"google-b_ie","icon":"icon-SwRL"};